<template>
  <div>
    <v-container class="toggle animated" fluid>
      <v-row dense>
        <v-col
          cols="12"
          class="d-flex justify-space-between align-center flex-wrap ga-2"
        >
          <div>
            <div
              class="text-h6"
              style="
                font-family:
                  Saira Condensed,
                  sans-serif;
              "
            >
              {{ $t("SocialsConfig.Title") }}
            </div>
            <div
              class="text-subtitle-2"
              style="
                font-family:
                  Saira Condensed,
                  sans-serif;
              "
            >
              {{ $t("SocialsConfig.SubTitle") }}
            </div>
          </div>
          <v-btn
            color="primary"
            prepend-icon="mdi-refresh"
            :loading="loading"
            @click="init()"
            style="
              font-family:
                Saira Condensed,
                sans-serif;
            "
          >
            {{ $t("SocialsConfig.Refresh") }}
          </v-btn>
        </v-col>

        <v-col cols="12" md="6">
          <v-card class="rounded-lg">
            <v-card-text>
              <div
                class="text-caption text-grey"
                style="
                  font-family:
                    Saira Condensed,
                    sans-serif;
                "
              >
                {{ $t("SocialsConfig.TotalConfigurations") }}
              </div>
              <div
                class="text-h5 font-weight-bold"
                style="
                  font-family:
                    Saira Condensed,
                    sans-serif;
                "
              >
                {{ totalConfigs }}
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="6">
          <v-card class="rounded-lg">
            <v-card-text>
              <div
                class="text-caption text-grey"
                style="
                  font-family:
                    Saira Condensed,
                    sans-serif;
                "
              >
                {{ $t("SocialsConfig.PublicConfigurations") }}
              </div>
              <div
                class="text-h5 font-weight-bold"
                style="
                  font-family:
                    Saira Condensed,
                    sans-serif;
                "
              >
                {{ publicConfigs }}
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col v-if="loading" cols="12">
          <v-progress-linear
            indeterminate
            color="primary"
            height="5"
            class="mt-1 rounded-lg"
          ></v-progress-linear>
        </v-col>

        <v-col
          v-for="platform in socialPlatforms"
          :key="platform.key"
          cols="12"
          md="6"
        >
          <v-card class="rounded-lg h-100">
            <v-card-title
              class="d-flex align-center"
              style="
                font-family:
                  Saira Condensed,
                  sans-serif;
              "
            >
              <v-icon class="mr-2">{{ platform.icon }}</v-icon>
              {{ platform.label }}
            </v-card-title>
            <v-card-text
              style="
                font-family:
                  Saira Condensed,
                  sans-serif;
              "
            >
              <div class="text-caption text-grey mb-1">
                {{ $t("SocialsConfig.CurrentValue") }}
              </div>
              <div class="text-body-1 text-truncate">
                {{
                  getSocialValue(platform.key) ||
                  $t("SocialsConfig.NotConfigured")
                }}
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                variant="flat"
                @click="openSocialDialog(platform)"
                style="
                  font-family:
                    Saira Condensed,
                    sans-serif;
                "
              >
                {{ $t("SocialsConfig.Configure") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="isDialogOpen" width="520" persistent>
      <v-card class="rounded-lg">
        <v-card-title
          style="
            font-family:
              Saira Condensed,
              sans-serif;
            background-color: #373f49;
            color: white;
          "
        >
          {{ $t("SocialsConfig.ConfigurePlatform") }}
        </v-card-title>
        <v-card-text
          class="pt-5"
          style="
            font-family:
              Saira Condensed,
              sans-serif;
          "
        >
          <v-text-field
            v-model="form.name"
            :label="$t('SocialsConfig.Platform')"
            readonly
            variant="outlined"
            class="mb-3"
          ></v-text-field>

          <v-text-field
            v-model="form.value"
            :label="$t('SocialsConfig.UrlOrHandle')"
            variant="outlined"
            :rules="[formRules.required]"
          ></v-text-field>
        </v-card-text>
        <v-card-actions class="pb-4 pr-4">
          <v-spacer></v-spacer>
          <v-btn
            variant="outlined"
            :disabled="saveLoading"
            @click="closeDialog()"
            style="
              font-family:
                Saira Condensed,
                sans-serif;
            "
          >
            {{ $t("Buttons.Cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            :loading="saveLoading"
            @click="saveSocialConfig()"
            style="
              font-family:
                Saira Condensed,
                sans-serif;
            "
          >
            {{ $t("Buttons.Save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar"
      :timeout="2500"
      color="secondary"
      location="top"
    >
      <v-icon>mdi-alert-circle</v-icon>
      <span
        class="ml-2"
        style="
          font-family:
            Saira Condensed,
            sans-serif;
        "
        >{{ snackText }}</span
      >
    </v-snackbar>
  </div>
</template>

<script>
import axios from "axios";
import { defineComponent } from "vue";

export default defineComponent({
  name: "SocialsConfig",
  data() {
    return {
      loading: false,
      saveLoading: false,
      configs: [],
      isDialogOpen: false,
      selectedPlatform: null,
      form: {
        name: "",
        value: "",
      },
      socialPlatforms: [
        { key: "social_discord", label: "Discord", icon: "mdi-discord" },
        { key: "social_twitter", label: "Twitter/X", icon: "mdi-twitter" },
        { key: "social_telegram", label: "Telegram", icon: "mdi-send" },
        { key: "social_youtube", label: "YouTube", icon: "mdi-youtube" },
        { key: "social_instagram", label: "Instagram", icon: "mdi-instagram" },
        { key: "social_kick", label: "Kick", icon: "mdi-sword-cross" },
      ],
      snackbar: false,
      snackText: "",
      formRules: {
        required: (value) => !!value || "Required",
      },
    };
  },
  computed: {
    totalConfigs() {
      return this.configs.length;
    },
    publicConfigs() {
      return this.configs.filter((item) => !item.isSensitive).length;
    },
  },
  methods: {
    getRequestHeaders() {
      const token = localStorage.getItem("abughazi-admin-accesstoken");
      return {
        Authorization: `Bearer ${token}`,
        "x-admin-key": process.env.VUE_APP_X_ADMIN_KEY,
      };
    },
    showSnack(message) {
      this.snackText = message;
      this.snackbar = true;
    },
    handleUnauthorized() {
      localStorage.removeItem("vuex");
      localStorage.removeItem("abughazi-admin-accesstoken");
      window.location.reload();
    },
    init() {
      const token = localStorage.getItem("abughazi-admin-accesstoken");
      if (!token) {
        this.handleUnauthorized();
        return;
      }

      this.loading = true;
      axios
        .get(process.env.VUE_APP_SERVER_URL + "/api/admin/configs", {
          headers: this.getRequestHeaders(),
        })
        .then((res) => {
          this.configs = (res?.data?.configs || []).map((config) => ({
            _id: config._id || "",
            name: config.name || "",
            description: config.description || "",
            value: config.value || "",
            isSensitive: !!config.isSensitive,
            createdAt: config.createdAt || "",
            updatedAt: config.updatedAt || "",
          }));
        })
        .catch((error) => {
          if (error?.response?.status === 401) {
            this.handleUnauthorized();
            return;
          }
          this.showSnack(this.$t("SocialsConfig.FailedToLoad"));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getSocialValue(key) {
      const config = this.configs.find((item) => item.name === key);
      return config ? config.value : "";
    },
    openSocialDialog(platform) {
      this.selectedPlatform = platform;
      this.form.name = platform.label;
      this.form.value = this.getSocialValue(platform.key);
      this.isDialogOpen = true;
    },
    closeDialog() {
      this.isDialogOpen = false;
      this.selectedPlatform = null;
      this.form.name = "";
      this.form.value = "";
    },
    async saveSocialConfig() {
      if (!this.selectedPlatform || !this.form.value) {
        return;
      }

      const payload = {
        name: this.selectedPlatform.key,
        value: this.form.value,
        description: `${this.selectedPlatform.label} link`,
        isSensitive: false,
      };

      this.saveLoading = true;
      try {
        await axios.post(
          process.env.VUE_APP_SERVER_URL + "/api/admin/configs",
          payload,
          {
            headers: this.getRequestHeaders(),
          },
        );

        this.showSnack(this.$t("SocialsConfig.ConfigSaved"));
        this.closeDialog();
        this.init();
      } catch (error) {
        if (error?.response?.status === 401) {
          this.handleUnauthorized();
          return;
        }
        this.showSnack(this.$t("SocialsConfig.FailedToSave"));
      } finally {
        this.saveLoading = false;
      }
    },
  },
  mounted() {
    this.init();
  },
});
</script>

<style scoped>
.h-100 {
  height: 100%;
}
</style>
